/**
 * 抽壳特征正式提交执行器。
 */

import type { Viewer } from '../../../../viewer';
import { ShellCommandAdapter } from '../../../command/shell/ShellCommandAdapter';
import type { ShellFeatureDefinitionModel } from '../../../definition/shell/ShellFeatureDefinition';
import type { FeatureEditSession } from '../../../edit/FeatureEditSession';
import type { ShellFeaturePrototype } from '../../../prototype/shell/ShellFeaturePrototype';
import type { FeatureExecutionRuntime } from '../../FeatureExecutionRuntime';
import { FeatureCommitExecution } from '../FeatureCommitExecution';

/**
 * 抽壳特征正式提交执行器。
 */
export class ShellCommitExecution extends FeatureCommitExecution<
    ShellFeatureDefinitionModel,
    ShellFeaturePrototype
> {
    /** 执行运行时。 */
    private readonly runtime: FeatureExecutionRuntime;
    /** 替换命令通道。 */
    private readonly replaceFeatureCommand: (featureId: string, command: CadCommand) => Promise<boolean>;
    /** 命令适配器。 */
    private readonly adapter: ShellCommandAdapter;

    /**
     * @param _viewer Viewer 实例。
     * @param runtime 执行运行时。
     * @param replaceFeatureCommand 替换命令回调。
     */
    public constructor(
        _viewer: Viewer,
        runtime: FeatureExecutionRuntime,
        replaceFeatureCommand: (featureId: string, command: CadCommand) => Promise<boolean>,
    ) {
        super();
        this.runtime = runtime;
        this.replaceFeatureCommand = replaceFeatureCommand;
        this.adapter = new ShellCommandAdapter();
    }

    /**
     * @inheritdoc
     */
    public async commitCreate(prototype: ShellFeaturePrototype): Promise<string> {
        const command = this.adapter.createCommandFromPrototype({
            prototype,
            clientId: 'web-client',
        }) as CadCommand;
        const result = await this.runtime.executeCommand(command);
        return result.objectId;
    }

    /**
     * @inheritdoc
     */
    public async commitEdit(
        session: FeatureEditSession<ShellFeatureDefinitionModel, ShellFeaturePrototype>,
        prototype: ShellFeaturePrototype,
    ): Promise<boolean> {
        const command = this.adapter.createCommandFromPrototype({
            prototype,
            clientId: 'web-client',
        }) as CadCommand;
        return this.replaceFeatureCommand(session.getPrototype().getFeatureId(), command);
    }
}
